import styled from 'styled-components'

const ImgWrapper = styled.div`
  margin: ${props => props.margin};
`

export default ImgWrapper
